import React, { Component } from "react";
import { connect } from "react-redux";

import Backdrop from "components/UI/Backdrop/Backdrop";
import Aux from "hoc/ReactAux/ReactAux";
import { checkValidity } from "../../../shared/utility";
import * as actions from "actions/index";
import "./RegisterCompany.css";

class RegisterCompany extends Component {
  state = {
    formIsValid: false,
    registerCompanyForm: {
      senderNameFrom: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      company: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      numberOfEmployees: {
        value: 0,
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      senderLastNameFrom: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      emailFrom: {
        value: "",
        validation: {
          required: true,
          email: true
        },
        valid: false,
        touched: false
      },
      phone: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      }
    }
  };

  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.onToggleRegisterCompany(false);
    }
  };

  handleSendEmail = () => {
    const payload = {};

    for (let formElementIndentifier in this.state.registerCompanyForm) {
      payload[formElementIndentifier] = this.state.registerCompanyForm[
        formElementIndentifier
      ].value;
    }
    this.props.onSendEmailToRegisterCompany(payload);
    this.setState({ showModal: true });
  };

  handleInputs = event => {
    let updateRegisterCompanyForm = {
      ...this.state.registerCompanyForm
    };

    let updateFormElement = {
      ...updateRegisterCompanyForm[event.target.name]
    };

    updateFormElement.value = event.target.value;

    updateFormElement.valid = checkValidity(
      updateFormElement.value,
      updateFormElement.validation
    );
    updateFormElement.touched = true;

    updateRegisterCompanyForm[event.target.name] = updateFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updateRegisterCompanyForm) {
      formIsValid =
        updateRegisterCompanyForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      registerCompanyForm: updateRegisterCompanyForm,
      formIsValid: formIsValid
    });
  };

  render() {
    let registerCompany = null;
    if (this.props.showRegisterCompany) {
      let disable = {
        cursor: "pointer"
      };

      if (!this.state.formIsValid) {
        disable = {
          background: "white",
          color: "#ff5007",
          border: "1px solid #ff5007",
          cursor: "not-allowed"
        };
      }

      registerCompany = (
        <Aux>
          <Backdrop show={true} />
          <div className="overlay connected">
            <div className="overlay-box">
              <button
                onClick={() => this.props.onToggleRegisterCompany(false)}
                type="button"
                className="bt-close mfp-close lb-fechar fa fa-times"
              />
              <h5>
                Please complete the form below to be connected with a lunch
                specialist
              </h5>
              <form>
                <div className="w-48 left">
                  <label>Name</label>
                  <input
                    tabIndex="1"
                    type="text"
                    name="senderNameFrom"
                    className={
                      !this.state.registerCompanyForm["senderNameFrom"].valid &&
                      this.state.registerCompanyForm["senderNameFrom"].touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                  <label>Company Name</label>
                  <input
                    tabIndex="3"
                    type="text"
                    name="company"
                    className={
                      !this.state.registerCompanyForm["company"].valid &&
                      this.state.registerCompanyForm["company"].touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                  <label>Number of Employees</label>
                  <input
                    tabIndex="5"
                    type="number"
                    name="numberOfEmployees"
                    className={
                      !this.state.registerCompanyForm["numberOfEmployees"]
                        .valid &&
                      this.state.registerCompanyForm["numberOfEmployees"]
                        .touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                </div>
                <div className="w-48 right">
                  <label>Last Name</label>
                  <input
                    tabIndex="2"
                    type="text"
                    name="senderLastNameFrom"
                    className={
                      !this.state.registerCompanyForm["senderLastNameFrom"]
                        .valid &&
                      this.state.registerCompanyForm["senderLastNameFrom"]
                        .touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                  <label>Email</label>
                  <input
                    tabIndex="4"
                    type="email"
                    name="emailFrom"
                    className={
                      !this.state.registerCompanyForm["emailFrom"].valid &&
                      this.state.registerCompanyForm["emailFrom"].touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                  <label>Phone</label>
                  <input
                    tabIndex="6"
                    type="number"
                    name="phone"
                    className={
                      !this.state.registerCompanyForm["phone"].valid &&
                      this.state.registerCompanyForm["phone"].touched
                        ? "Invalid"
                        : null
                    }
                    onChange={this.handleInputs}
                  />
                </div>
              </form>
              <a
                disabled={!this.state.formIsValid}
                style={disable}
                onClick={this.handleSendEmail}
                className="bt"
              >
                Send
              </a>
            </div>
          </div>
        </Aux>
      );
    }

    return registerCompany;
  }
}

const mapStateToProps = state => {
  return {
    showRegisterCompany: state.landingReducer.showRegisterCompany
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onToggleRegisterCompany: toggle =>
      dispatch(actions.toggleRegisterCompany(toggle)),
    onSendEmailToRegisterCompany: payload =>
      dispatch(actions.sendEmailToRegisterCompany(payload))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterCompany);



// WEBPACK FOOTER //
// ./src/containers/Landing/RegisterCompany/index.js